/* eslint-disable no-undef */
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader} from '@umahealth/occipital-ui/dist/compat'
import Camera from '../devices/camera'
import axios from 'axios'

const Photo = ({ prototype }) => {
    const navigate = useNavigate()
	const [camera, setCamera] = useState(true)
	const [loading, setLoading] = useState(false)


	const handleModelSubmit = async(file) => {
		console.log(file, prototype)
		try{
			setLoading(true)
			const endpointData = {}
			setLoading(true)
			const modelResult = await axios.post(prototype.url, endpointData, {
				headers: {
					'Content-Type': 'application/json',
					'x-api-key': process.env.REACT_APP_API_KEY_PHOTO
				}
			})
			console.log(modelResult)
		} catch (err) {
			console.log(err)
			setCamera(false)
		} finally {
			setLoading(false)
		}
        navigate('/output/model')
	}

	return (
		<>
			{loading && <Loader />}
			<div className='camera__test'>
				{camera &&  
					<>
						<Camera dataType='blob' onTakePhoto={(file) => handleModelSubmit(file)}/>
					</>
				}
			</div>
		</>
	)
}

export default Photo
